import Service from "../../service/index";

const Event = {
    namespaced: true,
    state: {
        event: null,
        optionEvent: [],
        patient_all: [],
        form: {
            // FORM 1
            id: null,                       // Primary Key
            event_id: null,                 // เลขที่เหตุการ
            case_id: null,                  // เลขที่ศพ

            received_case_date: null,       // วัน รับแจ้ง *
            received_case_at: null,         // เวลา รับแจ้ง
            departed_date:null,             // วัน รับแจ้ง *
            // departed_at_date: null,         // วัน รับแจ้ง *
            departed_at: null,              // เวลา เริ่มเดินทาง
            arrived_date: null,             // วัน ถึงสถานที่เกิดเหตุ *
            arrived_at: null,               // เวลา ถึงสถานที่เกิดเหตุ
            returned_date: null,            // วัน กลับจากที่เกิดเหตุ *
            returned_at: null,              // เวลา กลับจากที่เกิดเหตุ

            // ผู้สอบสวน
            response_officer_name: null,    // ชื่อพนักงานสอบสวนผู้แจ้ง
            police_station_id: null,        // สถานีตำรวจ
            doctor_name: null,              // แพทย์ชันสูตรร่วม
            circumstances_id: null,         // เหตุที่แจ้งเบื้องต้น

            // ผู้เสียชีวิต
            dead_name: null,                // ชื่อจริง
            dead_surname: null,             // นามสกุล *
            birthDate: null,                // วันเ/ดือน/ปี เกิด

            dead_age: null,                 // อายุ
            dead_id: null,                  // เลขบัตรประขาขน
            dead_gender: null,              // เพศ

            dead_nationality: null,         // สัญชาติ


            // ที่อยู่ผู้เสียชีวิต<ตามบัตรประชาชน>
            dead_address_idCard:null,       // ที่อยู่
            dead_place_address_idCard: null,       // ที่อยู่(สถานที่)
            address_village_no_idCard: null,       // หมู้บ้าน
            address_street_idCard: null,           // ซอย
            address_road_idCard: null,             // ถนน
            address_province_id_idCard: null,      // จังหวัด
            address_district_id_idCard: null,      // อำเภอ
            address_sub_district_id_idCard: null,  // เขต



            // ที่อยู่ผู้เสียชีวิต<ปัจจุบัน>
            dead_place_address: null,       // ที่อยู่(สถานที่)
            address: null,                  // ที่อยู่
            address_village_no: null,       // หมู้บ้าน
            address_street: null,           // ซอย
            address_road: null,             // ถนน
            address_province_id: null,      // จังหวัด
            address_district_id: null,      // อำเภอ
            address_sub_district_id: null,  // เขต


            // สถานที่ตาย
            dead_place_at: null,            // สถานที่ตาย
            location: null,                 // ชื่อ สถานที่ตาย
            village_no: null,               // หมู่
            location_lat: null,             // Latitude
            location_lng: null,             // Longitude
            location_province_id: null,     // จังหวัด
            location_district_id: null,     // อำเภอ
            location_sub_district_id: null, // เขต
            location_style: null,           // ลักษณะของสถานที่ที่พบศพนั้นอยู่ (พิมพ์)

            short_history: null,            // ผู้เสียชีวิต ประวัติโดยสังเขป (พิมพ์)
            found_date: null,               // วันศพถูกพบ
            found_at: null,                 // เวลาที่สพถูกพบ
            found_name: null,               // ชื่อผู้แจ้งพบศพ

            treat_history: null,            // ผู้เสียชีวิต ประวัติการรักษา/โรคประจำตัว (พิมพ์)
            last_found_date: null,          // วัน ที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย
            last_found_at: null,            // เวลา ที่มีผู้พบว่ามีชีวิตอยู่เป็นครั้งสุดท้าย

            death_reason_id: null,          // สาเหตุการตาย
            death_reason_addition: null,    // พฤติการณ์ที่ตาย
            death_reason_addition_detail: null, // รายละเอียดพฤติการณ์ที่ตาย

            // สภาพหรือชิ้นส่วนของศพที่ปรากฏ (appearances table)
            shape_id: null,                 // รูปร่าง
            height: null,                   // ส่วนสูง (พิมพ์)
            skin_color_id: null,            // ผิวสี
            skin_color_other: null,         // ผิวสี อื่นๆ (พิมพ์)
            hair_style_id: null,            // เส้นผม
            hair_color: null,               // สีผม (พิมพ์)
            accessory:null,                 // เครื่องประดับ
            defect: null,                   // รอยสัก/ตำหนิ/แผลเป็น
            cloth:null,                     // เสื้อผ้าเครื่องแต่งกาย

            // FORM 2
            // การเปลี่ยนแปลงภายหลังการตาย
            supravital_reaction_id: null,   // การกระตุ้นกล้ามเนื้อลาย (Supravital Reaction)
            temp: null,                     // อุณหภูมิของศพโดยการสัมผัส
            // การแข็งตัวของศพ (Rigor Mortis)
            jaw : null,                     // กราม
            note_jaw : null,                // กราม > หมายเหตุ
            neck : null,                    // คอ
            note_neck : null,               // คอ > หมายเหตุ
            knuckle : null,                 // ข้อนิ้ว
            note_knuckle : null,            // ข้อนิ้ว > หมายเหตุ
            elbow : null,                   // ข้อศอก
            note_elbow : null,              // ข้อศอก > หมายเหตุ
            shoulder_joint : null,          // ข้อไหล่
            note_shoulder_joint : null,     // ข้อไหล่ > หมายเหตุ
            hip_joint : null,               // ข้อสะโพก
            note_hip_joint : null,          // ข้อสะโพก > หมายเหตุ
            knee_joint : null,              // ข้อเข่า
            note_knee_joint : null,         // ข้อเข่า > หมายเหตุ
            ankle : null,                   // ข้อเท้า
            note_ankle : null,              // ข้อเท้า > หมายเหตุ
            other : null,                   // อื่นๆ
            note_other : null,              // อื่นๆ > หมายเหตุ

            livor_mortis_id: null,          // การตกของเลือดสูเ่บื้องต่ำภายหลังตาย (Livor Mortis)
            livor_mortis_area: null,        // การตกของเลือดสูเ่บื้องต่ำภายหลังตาย > ตำแหน่งที่พบ
            blood_type_id: null,            // ลักษณะจางของสีเมื่อกด
            blood_color_id: null,           // สีที่ปรากฏ
            blood_color_other: null,        // สีที่ปรากฏ > อื่นๆ
            rot_type_id: null,              // ศพเน่า
            rot_type_other: null,           // ศพเน่า > อื่่นๆ

            // การบาดเจ็บ และ/หรือพยาธิสภาพที่ตรวจพบ
            eye_injury_type_id:null,        // เยื่อบุตา
            eye_injury_type_other:null,     // เยื่อบุตา > อื่่นๆ
            is_body_injury_found:null,      // พยาธิสภาพอื่นๆ
            body_injury_found:null,         // พยาธิสภาพอื่นๆ > พบ (ระบุ)
            is_has_injury:null,             // บาดแผลที่ตรวจ
            item_found_amount : null,       // จำนวนการเก็บวัตถุพยานจากการชันสูตรพลิกศพ

            assumed_cause:null,             // ข้อสันนิษฐานการตายเบื้องต้น
            dead_management_id:null,        // ได้จัดการกับศพนั้นอย่างไร
            dead_management_other:null,     // ได้จัดการกับศพนั้นอย่างไร > อื่นๆ
            remark:null,                    // บันทึกอื่นๆ

            // ลงชื่อ
            officer_name:null,
            officer_email:null,
            officer_position:null,
            sign_doctor_name:null,
            doctor_email:null,
            doctor_position:null,
            represent_name:null,
            represent_email:null,
            represent_position:null,
            attorney_name:null,
            attorney_email:null,
            attorney_position:null,
            admin_name:null,
            admin_email:null,
            admin_position:null,
        },

        // การเก็บวัตถุพยานจากการชันสูตรพลิกศพ
        // evidences table
        evidences: {
            no: null,                       // ลำดับที่
            evidence: null,                 // วัตถุพยาน
            type: null,                     // ชนิดวัตถุพยาน
            location: null,                 // เก็บจาก(ตำแหน่ง)
            amount: null,                   // จำนวน
        },


        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search:{
            name: "",
            province: "",
            start_date: "",
            end_date: "",
        }
    },
      mutations: {
          SET_EVENT:(state,res)=>{
            state.event = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_EVENT_BY_ID:(state,res)=>{
            state.form = res;
            state.startLocation ={
                lat: res.lat,
                lng: res.lng
            }
        },
        GET_PATIENT_ALL:(state,res)=>{
            state.patient_all = res;
        },
        GET_EVENT_ALL:(state,res)=>{
            state.optionEvent = res;
        },
        SET_FORM_EVENT:(state,res)=>{
            state.form = res;
        },
        CLEAR_FORM_DATA: state => {
            state.form = {
                id: null,
                event_id: null,
                case_id: null,
                received_case_at: null,
                departed_at: null,
                arrived_at: null,
                returned_at: null,
                response_officer_name: null,
                police_station_id: null,
                doctor_name: null,
                circumstances_id: null,
                dead_name: null,
                dead_age: null,
                dead_id: null,
                dead_gender: null,
                birthDate: null,
                dead_address_idCard: null,
                dead_place_address_idCard: null,
                address_village_no_idCard: null,
                address_street_idCard: null,
                address_road_idCard: null,
                address_province_id_idCard: null,
                address_district_id_idCard: null,
                address_sub_district_id_idCard: null,
                dead_place_address: null,
                address: null,
                address_village_no: null,
                address_street: null,
                address_road: null,
                address_province_id: null,
                address_district_id: null,
                address_sub_district_id: null,
                location: null,
                village_no: null,
                lat: null,
                lon: null,
                location_province_id: null,
                location_district_id: null,
                location_sub_district_id: null,
                location_style: null,
                short_history: null,
                found_name: null,
                treat_history: null,

                found_at: null,
                last_found_at: null,
                found_date: null,
                last_found_date: null,
                death_reason_id: null,
                death_reason_addition: null,
                death_reason_addition_detail: null,
                shape_id: null,
                height: null,
                skin_color_id: null,
                skin_color_other: null,
                hair_style_id: null,
                hair_color: null,
            };
        },
          CLEAR_FORM_DATAS: state => {
              state.forms = {
                  case_id: null,
                  //table appea
                  cloth:null,
                  accessory:null,
                  defect: null,
                  //11.1 11.2
                  supravital_reaction_id: null,
                  temp: null,
                  //11.4 ทำแล้ว
                  livor_mortis_id: null,
                  livor_mortis_area: null,
                  blood_type_id: null,
                  blood_color_id: null,
                  blood_color_other: null,
                  rot_type_id: null,
                  rot_type_other: null,
                  //12 table case
                  eye_injury_type_id:null,
                  eye_injury_type_other:null,
                  is_body_injury_found:null,
                  body_injury_found:null,
                  is_has_injury:null,
                  has_injury:null, //ไม่ได้ใส่
                  is_evidence:null,
                  evidences:null, //ไมไ่ด้ใส่
                  assumed_cause:null,
                  dead_management_id:null,
                  dead_management_other:null,
                  remark:null,
                  officer_name:null,
                  officer_email:null,
                  officer_position:null,
                  sign_doctor_name:null,
                  doctor_email:null,
                  doctor_position:null,
                  represent_name:null,
                  represent_email:null,
                  represent_position:null,
                  attorney_name:null,
                  attorney_email:null,
                  attorney_position:null,
                  admin_name:null,
                  admin_email:null,
                  admin_position:null,
                  //11.3
                  jaw : null,
                  note_jaw : null,
                  neck : null,
                  note_neck : null,
                  knuckle : null,
                  note_knuckle : null,
                  elbow : null,
                  note_elbow : null,
                  shoulder_joint : null,
                  note_shoulder_joint : null,
                  hip_joint : null,
                  note_hip_joint : null,
                  knee_joint : null,
                  note_knee_joint : null,
                  ankle : null,
                  note_ankle : null,
                  other : null,
                  note_other : null,
              };
          },
        CLEAR_SEARCH: state => {
            state.search = {
                name: "",
                province: "",
                start_date: "",
                end_date: "",
            };
        },
    },
    actions: {
        setEvent({commit},data) {
          return Service.Event.getEvent(data.page, data.field, data.sortType,data.area_id,data.user_type_id,data.province_id,data.hospital_code).then(res => {
                commit("SET_EVENT", res);
            });
        },
        getPatientAll({commit}) {
            return Service.Event.countPatient().then(res => {
                commit("GET_PATIENT_ALL", res);
            });
        },
        setEventAll({commit}) {
            return Service.Event.getEventAll().then(res => {
                commit("GET_EVENT_ALL", res);
            });
        },
        saveEvent({commit},{data}){
                commit("SET_FORM_EVENT",data);
        },
        showEvent({commit},id){
            return Service.Event.showEventById(id).then(res=>{
                commit("GET_EVENT_BY_ID",res);
            })
        },
        search({commit},data){
            return Service.Event.searchEvent(data).then(res=>{
                commit("SET_EVENT",res)
            })
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        clearFormDatas({ commit }) {
            commit("CLEAR_FORM_DATAS");
        },
        clearSearch({ commit }) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default Event;
